import { render, staticRenderFns } from "./MBEService.vue?vue&type=template&id=7084f2ca&scoped=true&"
import script from "./MBEService.vue?vue&type=script&lang=ts&"
export * from "./MBEService.vue?vue&type=script&lang=ts&"
import style0 from "./MBEService.vue?vue&type=style&index=0&id=7084f2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084f2ca",
  null
  
)

export default component.exports